import React from 'react';
import './App.css';

function App() {
  const siteName = 'Page Brand Generator';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
